// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/response_documents.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddSectionCommentRequest, AddSectionCommentResponse, ApplyAssistOperationsRequest, ApplyAssistOperationsResponse, ArchiveDraftRequest, ArchiveDraftResponse, CompareVersionsRequest, CompareVersionsResponse, DownloadDocumentRequest, DownloadDocumentResponse, FixSectionAnchorsRequest, FixSectionAnchorsResponse, GetResponseWorkspaceRequest, GetResponseWorkspaceResponse, GetVersionViewSessionRequest, GetVersionViewSessionResponse, ImportDocxVersionRequest, ImportDocxVersionResponse, InsertSourceRequest, InsertSourceResponse, LabelVersionRequest, LabelVersionResponse, ListDocumentCommentsRequest, ListDocumentCommentsResponse, ListDocumentVersionsRequest, ListDocumentVersionsResponse, ListWorkspaceSourcesRequest, ListWorkspaceSourcesResponse, MarkSectionReadyRequest, MarkSectionReadyResponse, PromoteDraftRequest, PromoteDraftResponse, PutSectionHeadingBackRequest, PutSectionHeadingBackResponse, ResolveDocumentCommentRequest, ResolveDocumentCommentResponse, ResponseDocumentServiceCreateDraftRequest, ResponseDocumentServiceCreateDraftResponse, ResponseDocumentServiceGetExactPageCountRequest, ResponseDocumentServiceGetExactPageCountResponse, ResponseDocumentServiceRenameDraftRequest, ResponseDocumentServiceRenameDraftResponse, RestoreDocumentVersionRequest, RestoreDocumentVersionResponse } from "./response_documents_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ResponseDocumentService is the browser edge around the ONLYOFFICE editor
 * for RFI response documents and proposal volume documents (WRT-03): drafts,
 * versions, read-only version view, restore, import, download and the
 * workspace summary.
 *
 * Authorization (30-writing-workspace.md §3.7), checked here; pangaea and
 * shirohige trust the service lane:
 *   RFI      read = rfi_response read + view_sensitive; write = update;
 *            comment = FND-25 review.comment; export = rfi.export;
 *            approve = rfi.approve_answer (hard deny for AI/service principals)
 *   proposal read = project membership; write = project write access;
 *            comment = proposal.comment; export = proposal.document_export
 * Every RPC that takes a document id checks it belongs to the container
 * (NotFound otherwise). Write RPCs need the writing_workspace_v1 flag
 * (FailedPrecondition when off); reads always work.
 *
 * @generated from service mono.projectdata.v1.ResponseDocumentService
 */ export const ResponseDocumentService = {
    typeName: "mono.projectdata.v1.ResponseDocumentService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.GetResponseWorkspace
     */ getResponseWorkspace: {
            name: "GetResponseWorkspace",
            I: GetResponseWorkspaceRequest,
            O: GetResponseWorkspaceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ListDocumentVersions
     */ listDocumentVersions: {
            name: "ListDocumentVersions",
            I: ListDocumentVersionsRequest,
            O: ListDocumentVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.LabelVersion
     */ labelVersion: {
            name: "LabelVersion",
            I: LabelVersionRequest,
            O: LabelVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.RestoreDocumentVersion
     */ restoreDocumentVersion: {
            name: "RestoreDocumentVersion",
            I: RestoreDocumentVersionRequest,
            O: RestoreDocumentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.GetVersionViewSession
     */ getVersionViewSession: {
            name: "GetVersionViewSession",
            I: GetVersionViewSessionRequest,
            O: GetVersionViewSessionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.CreateDraft
     */ createDraft: {
            name: "CreateDraft",
            I: ResponseDocumentServiceCreateDraftRequest,
            O: ResponseDocumentServiceCreateDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.RenameDraft
     */ renameDraft: {
            name: "RenameDraft",
            I: ResponseDocumentServiceRenameDraftRequest,
            O: ResponseDocumentServiceRenameDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.PromoteDraft
     */ promoteDraft: {
            name: "PromoteDraft",
            I: PromoteDraftRequest,
            O: PromoteDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ArchiveDraft
     */ archiveDraft: {
            name: "ArchiveDraft",
            I: ArchiveDraftRequest,
            O: ArchiveDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ImportDocxVersion
     */ importDocxVersion: {
            name: "ImportDocxVersion",
            I: ImportDocxVersionRequest,
            O: ImportDocxVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.DownloadDocument
     */ downloadDocument: {
            name: "DownloadDocument",
            I: DownloadDocumentRequest,
            O: DownloadDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-29 "Fix section links": forcesave, then an untracked
     * ensure_heading_anchors apply on the document.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.FixSectionAnchors
     */ fixSectionAnchors: {
            name: "FixSectionAnchors",
            I: FixSectionAnchorsRequest,
            O: FixSectionAnchorsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-17 "Mark ready for pink": forcesave, stamp the section's region hash
     * as ready, label the version when unlocked (write access +
     * writing_workspace_v1).
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.MarkSectionReady
     */ markSectionReady: {
            name: "MarkSectionReady",
            I: MarkSectionReadyRequest,
            O: MarkSectionReadyResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-17 "Put it back": re-insert the heading of an orphaned proposal section
     * (structural insert_section at its old position), after a forcesave.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.PutSectionHeadingBack
     */ putSectionHeadingBack: {
            name: "PutSectionHeadingBack",
            I: PutSectionHeadingBackRequest,
            O: PutSectionHeadingBackResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-13: measure a DOCX version's exact pages (DS ConvertService); read
     * access; rate-limited to one call per document per 30 s per user.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.GetExactPageCount
     */ getExactPageCount: {
            name: "GetExactPageCount",
            I: ResponseDocumentServiceGetExactPageCountRequest,
            O: ResponseDocumentServiceGetExactPageCountResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-10: eligible sources for one section (read). Every producer runs as
     * the caller and applies its own access rule, so unreadable items are absent.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ListWorkspaceSources
     */ listWorkspaceSources: {
            name: "ListWorkspaceSources",
            I: ListWorkspaceSourcesRequest,
            O: ListWorkspaceSourcesResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-10: insert a citable source as a tracked insertion plus a "Specra
     * Sources" comment, or cite hearsay as a labelled comment only (update +
     * writing_workspace_v1).
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.InsertSource
     */ insertSource: {
            name: "InsertSource",
            I: InsertSourceRequest,
            O: InsertSourceResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-08 (FND-27 AWR-1..6): a person accepts a Specra Assist proposal on a
     * DOCX. Applied as tracked changes under "<name> via Specra Assist", with a
     * base-version staleness check; target "new_draft" lands it in a new
     * alternate draft instead of the main document. NotFound "not a response
     * document" when document_id is not a response document (the FE falls back
     * to its legacy path). Assist/agent/service principals are refused.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ApplyAssistOperations
     */ applyAssistOperations: {
            name: "ApplyAssistOperations",
            I: ApplyAssistOperationsRequest,
            O: ApplyAssistOperationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-31: section-aware word diff between two versions (read access).
     * to_document_id compares a draft against its main.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.CompareVersions
     */ compareVersions: {
            name: "CompareVersions",
            I: CompareVersionsRequest,
            O: CompareVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-12: saved DOCX comments; writes use comment authority, not text-edit authority.
     *
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ListDocumentComments
     */ listDocumentComments: {
            name: "ListDocumentComments",
            I: ListDocumentCommentsRequest,
            O: ListDocumentCommentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.ResolveDocumentComment
     */ resolveDocumentComment: {
            name: "ResolveDocumentComment",
            I: ResolveDocumentCommentRequest,
            O: ResolveDocumentCommentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.ResponseDocumentService.AddSectionComment
     */ addSectionComment: {
            name: "AddSectionComment",
            I: AddSectionCommentRequest,
            O: AddSectionCommentResponse,
            kind: MethodKind.Unary
        }
    }
};
